import { useState, useEffect } from 'react';
import './HomePreview.css';
import BlogGrid from './BlogGrid';
import staticPosts from '../data/posts';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Home page preview — the latest posts as an animated static grid.
export default function BlogPreview() {
  const [posts, setPosts] = useState(staticPosts);

  useEffect(() => {
    fetch(`${API_BASE}/api/blog`)
      .then(r => r.json())
      .then(data => {
        const normalized = data.map(p => ({
          ...p,
          img: p.img.startsWith('/uploads/') ? `${API_BASE}${p.img}` : p.img
        }));
        if (normalized.length) setPosts(normalized);
      })
      .catch(() => {});
  }, []);

  return (
    <section id="blog-preview" className="blog-section bp-section">
      <div className="bp-header reveal">
        <span className="section-label">Latest Insights</span>
        <h2 className="section-title">From Our <em>Blog</em></h2>
        <p className="section-sub">Stay updated with the latest trends, tips, and strategies in digital marketing and web development.</p>
      </div>

      <BlogGrid posts={posts.slice(0, 3)} />

      <div className="home-more reveal">
        <a href="#/blog" className="btn-ghost">View All Posts →</a>
      </div>
    </section>
  );
}
